



























































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as _ from "lodash";
import {
  PostFuwugailanJigouzongti,
  PostFuwugailanYuequshi,
  PostFuwugailanFuwuliangfenbu,
  PostFuwugailanZhongdian
} from "@/request/hdr";
import TimeSelect from "./time-type-select.vue";
@Component({
  components: {
    TimeSelect
  }
})
export default class HdrAnalysisReportGailan extends Vue {
  @Prop()
  private selectedHospitals: any;
  private message: any = {
    机构总体情况: {},
    机构月服务趋势图: {},
    各机构服务量分布状况: {
      柱状图: {
        data: []
      },
      饼图: {
        data: []
      }
    },
    重点人群服务量分布状况: {}
  };
  private cYear: number = new Date().getFullYear();
  private timeType: any = {
    各机构服务量分布状况: "全部时间",
    重点人群服务量分布状况: "全部时间"
  };
  private customTime: any = {
    各机构服务量分布状况: [],
    重点人群服务量分布状况: []
  };
  private peopleType: any = "全部";
  private loaded: boolean = false;
  private colors: any = [
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC"
  ];
  private pieColors: any = [
    "#50A7F9",
    "#69D688",
    "#FEDB57",
    "#BA95F8",
    "#F4AF6E",
    "#F88AA9"
  ];
  private yuequshi: any = {
    tooltip: {
      show: true,
      trigger: "item"
    },
    grid: {
      left: "5%",
      right: "2%",
      top: "40",
      bottom: "40"
    },
    xAxis: {
      type: "category",
      axisLabel: {
        color: "rgba(0,0,0,0.45)"
      },
      axisLine: {
        lineStyle: {
          color: "rgba(0,0,0,0.45)"
        }
      }
    },
    yAxis: {
      type: "value",
      axisLine: {
        show: false
      }
    },
    series: [
      {
        type: "bar",
        data: [],
        itemStyle: {
          color: "#6C99F6"
        }
      }
    ]
  };
  private fuwuliangfenbuBingtu: any = {
    grid: {},
    tooltip: {},
    color: this.colors,
    series: [
      {
        type: "pie",
        data: [],
        radius: ["50%", "70%"]
      }
    ]
  };
  private zhongdianPieBase: any = {
    grid: {},
    tooltip: {
      formatter: (params: any) => {
        if (params.dataIndex === 1) {
          return "";
        } else {
          return params.name + ":" + params.percent + "%";
        }
      }
    },
    series: [
      {
        type: "pie",
        data: [],
        label: {
          position: "center",
          formatter: (params: any) => {
            if (params.dataIndex === 1) {
              return "";
            } else {
              return params.value;
            }
          },
          fontSize: 26
        },
        radius: ["50%", "70%"]
      }
    ]
  };
  private zhongdianPies: any[] = [];
  private get years() {
    const arr: any = [];
    const currentYear = new Date().getFullYear();
    Array.of(0, 1, 2, 3, 4).forEach((i: any) => {
      arr.push(currentYear - i);
    });
    return arr;
  }
  /**
   * @description 获取服务概览统计机构总体数据
   */
  private fuwugailanJigouzongti() {
    const ids: any = [];
    this.selectedHospitals.forEach((h: any) => {
      ids.push(h.hospital_id);
    });
    const params: any = {
      hospital_ids: ids
    };
    PostFuwugailanJigouzongti(this, params).then((data: any) => {
      this.message["机构总体情况"] = data;
    });
  }
  /**
   * @description 获取服务概览机构月服务趋势图
   */
  private fuwugailanYuequshi() {
    const ids: any = [];
    this.selectedHospitals.forEach((h: any) => {
      ids.push(h.hospital_id);
    });
    const params: any = {
      hospital_ids: ids,
      year: this.cYear
    };
    PostFuwugailanYuequshi(this, params).then((data: any) => {
      this.message["机构月服务趋势图"] = data;
      this.createYuequshi();
    });
  }
  /**
   * @description 月趋势年份改变
   */
  private yearChange(year) {
    this.cYear = year;
    this.fuwugailanYuequshi();
  }
  /**
   * @description 创建月趋势图
   */
  private createYuequshi() {
    this.yuequshi.series[0].data = this.message["机构月服务趋势图"]["data"];
    this.yuequshi.xAxis.data = this.message["机构月服务趋势图"]["title"];
  }
  /**
   * @description 获取各机构服务量分布状况
   */
  private fuwuliangfenbu() {
    const ids: any = [];
    this.selectedHospitals.forEach((h: any) => {
      ids.push(h.hospital_id);
    });
    const params: any = {
      hospital_ids: ids,
      人群: this.peopleType
    };
    if (this.timeType["各机构服务量分布状况"] !== "自定义") {
      params["统计时间"] = this.timeType["各机构服务量分布状况"];
    } else {
      params["开始时间"] = this.customTime["各机构服务量分布状况"][0];
      params["结束时间"] = this.customTime["各机构服务量分布状况"][1];
    }
    PostFuwugailanFuwuliangfenbu(this, params).then((data: any) => {
      this.message["各机构服务量分布状况"]["柱状图"] = data["柱状图"];
      this.message["各机构服务量分布状况"]["饼图"] = data["饼图"];
      this.createFuwuliangfenbuBingtu();
    });
  }
  /**
   *
   */
  private createFuwuliangfenbuBingtu() {
    this.message["各机构服务量分布状况"]["饼图"]["data"].map((item: any) => {
      item.name = item.title;
    });
    this.fuwuliangfenbuBingtu.series[0].data = this.message[
      "各机构服务量分布状况"
    ]["饼图"]["data"];
  }
  /**
   * @description 服务量分布时间改变
   */
  private fuwuliangfenbuChange(type) {
    this.timeType["各机构服务量分布状况"] = type;
    this.fuwuliangfenbu();
  }
  /**
   * @description 服务量分布时间自定义改变
   */
  private fuwuliangfenbuCustomTimeChange(val) {
    this.customTime["各机构服务量分布状况"] = val;
    this.fuwuliangfenbu();
  }
  /**
   * @description 各机构服务量分布人种类型改变
   */
  private peopleTypeChange(type) {
    this.peopleType = type;
    this.fuwuliangfenbu();
  }
  /**
   * @description 计算各机构服务量分布的背景
   */
  private calBackground(index, item) {
    const style: any = {};
    style.backgroundColor = this.colors[index];
    if (!style.backgroundColor) {
      style.backgroundColor = "#000000";
    }
    style.width =
      item.ratio * 0.8 * (this.$refs.zongliang as any).offsetWidth + 40 + "px";
    return style;
  }
  /**
   * @description 获取重点人群服务量分布状况数据
   */
  private zhongdianfenbu() {
    const ids: any = [];
    this.selectedHospitals.forEach((h: any) => {
      ids.push(h.hospital_id);
    });
    const params: any = {
      hospital_ids: ids,
      人群: this.peopleType
    };
    if (this.timeType["重点人群服务量分布状况"] !== "自定义") {
      params["统计时间"] = this.timeType["重点人群服务量分布状况"];
    } else {
      params["开始时间"] = this.customTime["重点人群服务量分布状况"][0];
      params["结束时间"] = this.customTime["重点人群服务量分布状况"][1];
    }
    PostFuwugailanZhongdian(this, params).then((data: any) => {
      this.message["重点人群服务量分布状况"] = data;
      this.createZhongdian();
    });
  }
  /**
   * @description 创建重点人群服务量分布状况饼图群
   */
  private createZhongdian() {
    this.zhongdianPies = [];
    this.message["重点人群服务量分布状况"].data.forEach(
      (item: any, index: any) => {
        const tempPie: any = _.cloneDeep(this.zhongdianPieBase);
        item.name = item.title;
        const dataObj: any = _.cloneDeep(item);
        tempPie.title = {
          text: item.title,
          bottom: 0,
          left: "center"
        };
        tempPie.color = [this.pieColors[index], "#ECE9EC"];
        tempPie.series[0].data = [
          dataObj,
          { name: "", value: dataObj.value / dataObj.ratio - dataObj.value }
        ];
        this.zhongdianPies.push(tempPie);
      }
    );
  }
  /**
   * @description 重点人群服务量分布时间改变
   */
  private zhongdianChange(type) {
    this.timeType["重点人群服务量分布状况"] = type;
    this.zhongdianfenbu();
  }
  /**
   * @description 重点人群服务量分布时间自定义改变
   */
  private zhongdianCustomTimeChange(val) {
    this.customTime["重点人群服务量分布状况"] = val;
    this.zhongdianfenbu();
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.$watch(
      () => {
        return this.selectedHospitals;
      },
      () => {
        this.fuwugailanJigouzongti();
        this.fuwugailanYuequshi();
        this.fuwuliangfenbu();
        this.zhongdianfenbu();
      },
      {
        immediate: true
      }
    );
  }
}
